import { render } from "./ActionButton.vue?vue&type=template&id=d83160e8&scoped=true"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=d83160e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d83160e8"]])

export default __exports__